/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'ShopFeaturedGridItemBlock';
const CLS = 'shopFeaturedGridItemBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/shopFeaturedGridItemBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class ShopFeaturedGridItemBlock {
	constructor($el) {
		// $el is the widget node return by the
		// loadShopFeaturedGridItemBlock function
		this.$el = $el;
	}

	init() {
		this.setShopFeaturedGridItemBlock();
	}

	setShopFeaturedGridItemBlock() {
		// Add Some logic here
		const $wg = $(this.$el);

		$wg.on('mouseenter', function(e) {
			$wg.addClass(CLS + '-item--opened');
		});

		$wg.on('mouseleave', function(e) {
			$wg.removeClass(CLS + '-item--opened');
		});

		$wg.on('click', function(e) {
			$wg.toggleClass(CLS + '-item--opened');
		});
	}

	// Add more functions like on above here
}
